import { InMemoryHeader, InMemoryString } from "pbas-vue-components";

const InMemoryUnionsHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Identifier"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "globals.name",
    type: new InMemoryString("Name"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.links.language_code",
    type: new InMemoryString("LanguageCode"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.themesettings.link",
    type: new InMemoryString("Link", {
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px;'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),

  // new InMemoryHeader({
  //   title: "headers.links.language",
  //   type: new InMemoryString("Locals[]/Translations[]/LanguageCode", {
  //     getString: (item) =>
  //       item.Locals.map((o) => translate2(o, "Name")).join(", "),
  //     getHtml: (item, type) => {
  //       return (
  //         "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px;'>" +
  //         type.getString(item, type) +
  //         "</div>"
  //       );
  //     },
  //   }),
  //   sortable: true,
  //   visible: true,
  //   searchable: true,
  // }),
];
export default InMemoryUnionsHeaders;
